export default __webpack_public_path__ + "static/media/a037-e.05e75a6d.jpg";